import * as React from 'react';
import type { Reference } from '@chess/api-mistakes';

// The Learn card under the puzzle card while a puzzle is on the board: the
// motif the puzzle practises, up to three pages to learn it from (each
// opening outside the app), and how often the reader's mistakes of the last
// 30 days were of the same family, linking to those games in the library.
// Drawn from props only; the container in `index.tsx` turns the puzzle's
// motif, the service's references and the store's count into these props
// (`learn.ts`).

const SOURCE_LABEL: Record<Reference['source'], string> = { lichess: 'Lichess', wikipedia: 'Wikipedia', chesscom: 'Chess.com' };

export interface LearnCardProps {
  /** "Learn: Pin · against the queen". */
  title: string;
  /** At most three. */
  references: readonly Reference[];
  /** "3 of your blunders in the last 30 days were a pin", opening the library; absent when none or not known. */
  count?: { text: string; href: string };
  /** Opens the count's library address in the app; the link's href stands when absent. */
  onOpenCount?: (href: string) => void;
}

export const LearnCard: React.FC<LearnCardProps> = ({ title, references, count, onOpenCount }) => (
  <section className="panel learn-card" aria-label={title}>
    <h2 className="learn-card-title">{title}</h2>
    {references.length > 0 ? (
      <ul className="learn-card-list">
        {references.map((ref) => (
          <li key={ref.url} className="learn-card-item">
            <a className="learn-card-link" href={ref.url} target="_blank" rel="noopener noreferrer" title={ref.summary}>
              {ref.title}
            </a>
            <span className="learn-card-source">{SOURCE_LABEL[ref.source]}</span>
            <p className="learn-card-summary">{ref.summary}</p>
          </li>
        ))}
      </ul>
    ) : (
      <p className="panel-empty">No page on this one yet.</p>
    )}
    {count && (
      <p className="learn-card-count">
        <a
          className="learn-card-count-link"
          href={count.href}
          onClick={
            onOpenCount
              ? (e) => {
                  e.preventDefault();
                  onOpenCount(count.href);
                }
              : undefined
          }
        >
          {count.text}
        </a>
      </p>
    )}
  </section>
);
